import { render, staticRenderFns } from "./diffLabel.vue?vue&type=template&id=3b290834"
import script from "./diffLabel.vue?vue&type=script&lang=js"
export * from "./diffLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports